export default __webpack_public_path__ + "static/media/transformation-plan-eu.9ebc8028.svg";